import { NAV_MENU_ID_ENUM, NAV_MENU_LABELS } from 'constants/enums';
import {
  BaseRoute,
  ClaimsPrepayRoute,
  DocumentsRoute,
  HelpandSupportRoute,
  InvoicingRoute,
  RulesRoute,
  ClientsRoute,
  AppealResponsesRoute,
  ActivityLogRoute,
} from 'constants/routes';
import { UserProfile } from 'containers/Security/modules/types';
import AccessControl from 'components/Hoc/AccessControl';
import { PERMISSIONS } from 'containers/Security/modules/enums';

export const NAV_MENU_PERMISSIONS = {
  [NAV_MENU_LABELS.claims]: PERMISSIONS.CLAIM_SEARCH_VIEW_READ,
  [NAV_MENU_LABELS.documents]: PERMISSIONS.DOCUMENT_READ,
  [NAV_MENU_LABELS.invoicing]: PERMISSIONS.INVOICING_READ,
  [NAV_MENU_LABELS.rulespec]: PERMISSIONS.RULE_SPEC_READ,
  [NAV_MENU_LABELS.clientManagement]: PERMISSIONS.CLIENT_ADMIN_READ,
  [NAV_MENU_LABELS.appealResponses]: PERMISSIONS.ACTIVITY_LOG_READ,
  [NAV_MENU_LABELS.activityLog]: PERMISSIONS.ACTIVITY_LOG_READ,
  [NAV_MENU_LABELS.support]: PERMISSIONS.HELP_AND_SUPPORT_READ,
};

export const NAV_MENU_ITEMS = [
  {
    id: NAV_MENU_ID_ENUM.claims,
    label: NAV_MENU_LABELS.claims,
    path: ClaimsPrepayRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.documents,
    label: NAV_MENU_LABELS.documents,
    path: DocumentsRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.invoicing,
    label: NAV_MENU_LABELS.invoicing,
    path: InvoicingRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.rulespec,
    label: NAV_MENU_LABELS.rulespec,
    path: RulesRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.clientManagement,
    label: NAV_MENU_LABELS.clientManagement,
    path: ClientsRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.appealResponses,
    label: NAV_MENU_LABELS.appealResponses,
    path: AppealResponsesRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.activityLog,
    label: NAV_MENU_LABELS.activityLog,
    path: ActivityLogRoute,
  },
  {
    id: NAV_MENU_ID_ENUM.support,
    label: NAV_MENU_LABELS.support,
    path: HelpandSupportRoute,
  },
];

export const DEMO_USER: UserProfile = {
  given_name: 'TestUserNotLoggedIn',
  family_name: 'User1',
  email: '',
  phone: '',
  permissions: [],
  apps: [
    {
      name: 'Prepayment Insight & Review',
      id: '7c7-4ff9-b4a8-8e0a00354d8a',
      uri: 'https://sdfkjldfskjl.chhc.io',
    },
  ],
  user_id: 'Test_User',
  isInternalUser: false,
};

export const SUPPORT_MENU_ITEMS = [
  {
    id: 0,
    label: 'MenuItem1',
    path: '/',
  },
  {
    id: 1,
    label: 'MenuItem2',
    path: '/',
  },
  {
    id: 2,
    label: 'MenuItem3',
    path: '/',
  },
];

export const AVATAR_MENU_ITEMS = [
  [
    {
      id: 0,
      label: 'My Profile',
      path: '/',
    },
    {
      id: 1,
      label: 'My Views',
      path: '/',
    },
  ],
  [
    {
      id: 2,
      label: 'Log Out',
      path: '/logout',
    },
  ],
  [
    {
      id: 3,
      label: 'Altegra Health Plan',
      path: '/',
    },
    {
      id: 4,
      label: 'Lorem Ipsum Plan',
      path: '/',
    },
  ],
];

export const MULTI_SELECT_GROUP_ITEMS = {
  items: [
    {
      id: 'one',
      text: 'Multi-Select Group Label',
      items: [
        {
          id: 'two',
          text: 'Multi-Select Item',
          count: 2,
        },
        {
          id: 'three',
          text: 'Multi-Select Group Label',
          items: [
            {
              id: 'four',
              text: 'Multi-Select Item',
            },
            {
              id: 'five',
              text: 'Multi-Select Item',
            },
          ],
        },
      ],
    },
  ],
  domID: 'multi-select-group',
};

export const DEFAULT_LOGO_REDIRECT_PATH = `${BaseRoute}`;

export const ON_PRODUCT_MENU_SELECT = 'app/containers/PageWrapper/ON_PRODUCT_MENU_SELECT';
export const ON_AVATAR_MENU_SELECT = 'app/containers/PageWrapper/ON_AVATAR_MENU_SELECT';
export const ON_NAV_MENU_SELECT = 'app/containers/PageWrapper/ON_NAV_MENU_SELECT';
export const ON_MULTI_GROUP_OPEN = 'app/containers/PageWrapper/ON_MULTI_GROUP_OPEN';
export const ON_MULTI_GROUP_CHECK = 'app/containers/PageWrapper/ON_MULTI_GROUP_CHECK';
export const ON_SINGLE_GROUP_SELECT = 'app/view/PageWrapper/ON_SINGLE_GROUP_SELECT';
export const ON_SINGLE_GROUP_OPEN = 'app/view/PageWrapper/ON_SINGLE_GROUP_OPEN';
export const ON_SINGLE_SELECT_INQUIRIES = 'app/view/PageWrapper/ON_SINGLE_SELECT_INQUIRIES';
export const ON_SINGLE_SELECT_MY_RECENT_ACTIVITIES =
  'app/view/PageWrapper/ON_SINGLE_SELECT_MY_RECENT_ACTIVITIES';
export const ON_SINGLE_SELECT_RULES = 'app/view/PageWrapper/ON_SINGLE_SELECT_RULES';
export const ON_SINGLE_SELECT_REASON_CODES = 'app/view/PageWrapper/ON_SINGLE_SELECT_REASON_CODES';
export const ON_SINGLE_SELECT_DOCUMENT_REFERENCES =
  'app/view/PageWrapper/ON_SINGLE_SELECT_DOCUMENT_REFERENCES';
export const ON_SINGLE_SELECT_CLIENTS = 'app/view/PageWrapper/ON_SINGLE_SELECT_CLIENTS';
export const ON_SINGLE_SELECT_APPEAL_RESPONSES =
  'app/view/PageWrapper/ON_SINGLE_SELECT_APPEAL_RESPONSES';
export const ON_SINGLE_SELECT_ACTIVITY_LOG = 'app/view/PageWrapper/ON_SINGLE_SELECT_ACTIVITY_LOG';
export const ON_SINGLE_SELECT_CREATE_INVOICE = 'app/view/PageWrapper/ON_SINGLE_SELECT_CREATE_INVOICE';
export const ON_SINGLE_SELECT_INVOICE_SEARCH = 'app/view/PageWrapper/ON_SINGLE_SELECT_INVOICE_SEARCH';
export const ON_SINGLE_GROUP_SELECT_INVOICING = 'app/view/PageWrapper/ON_SINGLE_GROUP_SELECT_INVOICING';
export const SET_ASSIGNEE_LIST = 'app/view/PageWrapper/SET_ASSIGNEE_LIST';
export const SET_APPEAL_STATUSES = 'app/view/PageWrapper/SET_APPEAL_STATUSES';
export const SET_USER_CONFIGS = 'app/view/PageWrapper/SET_USER_CONFIGS';
export const USER_SET = 'app/containers/PageWrapper/USER_SET';
export const SET_NAV_MENU_ITEMS = 'app/containers/PageWrapper/SET_NAV_MENU_ITEMS';
export const TOGGLE_AUTH_MODAL_OPEN = 'app/containers/PageWrapper/TOGGLE_AUTH_MODAL_OPEN';
export const TOGGLE_USER_COLUMN_CONFIG_LOADING =
  'app/containers/PageWrapper/TOGGLE_USER_COLUMN_CONFIG_LOADING';
export const TOGGLE_ASSIGNEE_LIST_LOADING =
  'app/containers/PageWrapper/TOGGLE_ASSIGNEE_LIST_LOADING';
export const ON_INITIAL_NOTIFICATIONS = 'app/containers/PageWrapper/ON_INITIAL_NOTIFICATIONS';
export const ON_UPDATE_NOTIFICATIONS = 'app/containers/PageWrapper/ON_UPDATE_NOTIFICATIONS';
export const ON_UNPROCESSED_NOTIFICATIONS =
  'app/containers/PageWrapper/ON_UNPROCESSED_NOTIFICATIONS';
export const MARK_NOTIFICATIONS_READ = 'app/containers/PageWrapper/MARK_NOTIFICATIONS_READ';
export const TOGGLE_HASE_USER_ACKNOWLEDGED =
  'app/containers/PageWrapper/TOGGLE_HASE_USER_ACKNOWLEDGED';

export const SET_NETWORK_ERROR_NOTIFICATION =
  'app/containers/PageWrapper/SET_NETWORK_ERROR_NOTIFICATION';
export const SET_NOTIFICATION_VISIBLE = 'app/containers/PageWrapper/SET_NOTIFICATION_VISIBLE';
export const SET_OPEN_ANIMATION = 'app/containers/PageWrapper/SET_OPEN_ANIMATION';
export const SET_CLOSE_ANIMATION = 'app/containers/PageWrapper/SET_CLOSE_ANIMATION';
export const APP_ID = 'TEST';
